import React, {FC, ReactNode, useEffect, useState} from 'react';

import {Avatar} from '../../../../libs/shared/ui/src/components/avatar/avatar';
import {AvatarEditor} from '../../../../libs/shared/ui/src/components/avatar/avatarEditor';
import {AvatarImage} from '../../../../libs/shared/ui/src/components/avatar/avatarImage';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Types.
 */

interface AvatarInputProps {
  avatarFile: File | undefined;
  placeholder: ReactNode;
  isDisabled?: boolean;
  updateAvatarFile: (file: File) => void;
}

/*
 * Component.
 */

export const AvatarInput: FC<AvatarInputProps> = (props) => {
  const {avatarFile, placeholder, isDisabled, updateAvatarFile} = props;
  const [imageUrl, setImageUrl] = useState<string>();

  useEffect(() => {
    if (avatarFile) {
      const fileReader = new FileReader();
      fileReader.onload = (event: ProgressEvent<FileReader>) => {
        setImageUrl(event.target?.result?.toString() ?? '');
      };
      fileReader.readAsDataURL(avatarFile);
    }
  }, [avatarFile]);

  return (
    <AvatarEditor
      isDisabled={isDisabled}
      avatar={renderAvatarOrPlaceholder(imageUrl, placeholder)}
      onFileChange={(file: File) => updateAvatarFile(file)}
    />
  );
};

function renderAvatarOrPlaceholder(imageUrl: string | undefined, placeholder: ReactNode) {
  if (!imageUrl) {
    return placeholder;
  }

  return (
    <Avatar size={VisualSizesEnum.EXTRA_LARGE}>
      <AvatarImage imageUrl={imageUrl} />
    </Avatar>
  );
}
